import { QueryHookOptions } from '@apollo/client';
import { Paths } from 'type-fest';

import {
  ScanDataSubmissionFilter,
  GetScanDataSubmissionsQuery,
  GetScanDataSubmissionsQueryVariables,
  ScanDataSubmissionsFragment,
  useGetScanDataSubmissionsQuery,
} from '@occc/graphql';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';

import { transformDataToScanDataArray } from '../scan-data-weekly-file.utils';

type GetPastSubmissionsProps = {
  filter: ScanDataSubmissionFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<
    ScanDataSubmissionsFragment[],
    GetScanDataSubmissionsQueryVariables
  >;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
};

export const useGetScanDataSubmissions = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetPastSubmissionsProps) => {
  const response = usePaginatedQuery(
    useGetScanDataSubmissionsQuery,
    'scanDataSubmissions.pageInfo' satisfies Paths<GetScanDataSubmissionsQuery>,
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
      onCompleted: (data) => {
        if (baseOptions && baseOptions.onCompleted) {
          baseOptions.onCompleted(transformDataToScanDataArray(data));
        }
      },
    } as QueryHookOptions,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data ? transformDataToScanDataArray(response.data) : response.data,
  };
};
